// extracted by mini-css-extract-plugin
export default {"cabecalho":"Cabecalho_cabecalho__HMrxR","imagemLogo":"Cabecalho_imagemLogo__y5bqI","participante":"Cabecalho_participante__48+mh"};